import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";

type Props = {
  cancel: any;
  onfinish: any;
};

const ForgotPassword: React.FC<Props> = function (props) {
  const cancel = props.cancel;
  const onfinish = props.onfinish;
  return (<>
    <div className="cover"></div>
    <div className="modal-wrap">
      <div className="modal-reset">
        <div className="modal-reset-body">
          <button className="close-icon" onClick={cancel}>
            <CloseOutlined />
          </button>
          <div className="title-group">
            <p className="reset-title">Reset Password</p>
            <p className="subtitle">Enter your email address & we&apos;ll send you a new password.</p>
          </div>
          <Form onFinish={onfinish}  onKeyPress={(e) => { if(e.key === 'Enter'){e.preventDefault()}}}>
            <Form.Item
              name="email"
              rules={[{ type: 'email', required: true, message: "Please input your email!" }]}
            >
              <Input className="reset-email-input" />
            </Form.Item>
            <div className="button-group">
              <Button className="btn-send" type="primary" shape="round" size="large" htmlType="submit">
                Send
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div></>)
}

export default ForgotPassword;